<template>
    <div class="tools-buttons-container">
      <button
        class="button-container"
        :class="['tool-button', { active: selectedType === 'point' }]"
        @click="toggleTool('point')"
      >
        <p :class="{ active: selectedType === 'point' }">
          <v-icon :class="['material-icons', { active: selectedType === 'point' }]" small>circle</v-icon>
          {{ $t(`PointSelection`) }}
        </p>
      </button>
      <button
        class="button-container"
        :class="['tool-button', { active: selectedType === 'polygon' }]"
        style="opacity: 0.4;"
        @click="toggleTool('polygon')"
        :disabled="true"
      >
        <p :class="{ active: selectedType === 'polygon' }">
          <img :src="require(`@/assets/spf/polygon.png`)" style="width: 14px; height: 14px;">
          {{ $t(`PolygonSelection`) }}
        </p>
      </button>
    </div>
</template>
  
<script>
  export default {
    name: "ToolsButtons",
  
    data() {
      return {
        selectedType: null,
      };
    },
  
    methods: {
      toggleTool(tool) {
        if (this.selectedType === tool) {
          // Deselect the tool if it is already selected
          this.selectedType = null;
        } else {
          // Select the tool if it is not selected
          this.selectedType = tool;
        }
        this.$emit("set-selection", this.selectedType);
      },
    },
  };
</script>
  
<style scoped>
  .tools-buttons-container {
    display: flex;
    justify-content: space-between;
    gap: 5px;
  }
  
  .button-container {
    flex: 1;
    border: 1px solid black;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .tool-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .tool-button p {
    margin: 0;
  }
  
  .active {
    background-color: #4e4e4e; /* Change to desired active color */
    color: #ffffff; /* Change to desired active text color */
  }
  
  .active i {
    color: #ffffff; /* Change to desired active icon color */
  }
</style>


// WEBPACK FOOTER //
// src/components/Network/RightSidebar/ToolsButtons.vue